import axios from "axios";
import { useRecoilValue } from "recoil";
import { keyStore } from "../store/key.atom";

const axiosClient = axios.create();

export const useAxiosInstance = () => {
  const key = useRecoilValue(keyStore);

  axiosClient.defaults.baseURL = process.env.REACT_APP_BASE_URL;

  axiosClient.interceptors.request.use((config) => {
    if (key) {
      config.headers["Organization"] = key;
    }
    return config;
  });

  return axiosClient;
};
